import Vue from 'vue';
import VeeValidate from 'vee-validate';
import validator from 'utils/validator';

Vue.use(VeeValidate);

const dictionary = {
  pt: {
    messages: {
      required: () => 'O campo é obrigatório.',
      length: (value, args) => `O campo deve conter ${args} caracteres!`,
      alpha_num: () => 'O campo só aceita caracteres alfanuméricos',
      min: (value, args) => `O campo deve conter no mínimo ${args} caracteres!`,
      email: () => 'O email não é valido'
    }
  }
};

const removeMask = value => {
  const match = value.match(/\d/g);
  if (match) {
    return match.join('');
  }
  return '';
};

VeeValidate.Validator.localize('pt', dictionary.pt);

VeeValidate.Validator.extend('isNotEquals', {
  getMessage: () => 'Campo Inválido',
  validate: (value, [otherValue]) => validator('isNotEquals', { value, otherValue })
});

VeeValidate.Validator.extend('isBefore', {
  getMessage: () => 'Data Inválida',
  validate: (value, [otherValue]) => validator('isBefore', { value, otherValue })
});

VeeValidate.Validator.extend('hour', {
  getMessage: () => 'Horário inválido',
  validate: value => validator('hour', value)
});

VeeValidate.Validator.extend('cnpj', {
  getMessage: () => 'CNPJ inválido',
  validate: value => validator('cnpj', removeMask(value))
});

VeeValidate.Validator.extend('name', {
  getMessage: () => 'Nome inválido',
  validate: value => validator('name', value)
});
VeeValidate.Validator.extend('cpf', {
  getMessage: () => 'CPF inválido',
  validate: value => validator('cpf', removeMask(value))
});

VeeValidate.Validator.extend('lessToDay', {
  getMessage: () => 'A data informada deve ser anterior ao dia de hoje',
  validate: value => validator('lessToDay', value)
});

VeeValidate.Validator.extend('olderThan16', {
  getMessage: () => 'O cliente deve ser maior de 16 anos',
  validate: value => validator('olderThan16', value)
});

VeeValidate.Validator.extend('money', {
  getMessage: () => 'O valor é obrigatório',
  validate: value => validator('money', value)
});

VeeValidate.Validator.extend('afterToday', {
  getMessage: () => 'A data informada deve ser maior que a data atual',
  validate: value => validator('afterToday', value)
});

VeeValidate.Validator.extend('celPhone', {
  getMessage: () => 'Telefone inválido',
  validate: value => validator('celPhone', removeMask(value))
});

VeeValidate.Validator.extend('custCode', {
  getMessage: () => 'Codigo inválido',
  validate: value => validator('custCode', value)
});

VeeValidate.Validator.extend('registration', {
  getMessage: () => 'Matrícula inválida',
  validate: value => validator('registration', value)
});

VeeValidate.Validator.extend('password', {
  getMessage: () => 'Senha inválida',
  validate: value => validator('password', value)
});

VeeValidate.Validator.extend('curve', {
  getMessage: () => 'Curva deve ser entre A-F',
  validate: value => validator('curve', value)
});

VeeValidate.Validator.extend('newPassword', {
  getMessage: () =>
    'Formato de senha inválida! A senha deve conter letras (maiúsculas e minúsculas), números e caracteres especiais.',
  validate: value => validator('newPassword', value)
});

VeeValidate.Validator.extend('manySpaces', {
  getMessage: () => 'Muitos espaços agrupados',
  validate: value => validator('manySpaces', value)
});

VeeValidate.Validator.extend('noSpaces', {
  getMessage: () => 'O campo não pode conter espaços',
  validate: value => validator('noSpaces', value)
});

VeeValidate.Validator.extend('validateImei', {
  getMessage: () => 'IMEI inválido',
  validate: value => validator('validateImei', value)
});
